import { render, staticRenderFns } from "./BlockGroup.vue?vue&type=template&id=6dbdfabd&scoped=true&lang=pug"
import script from "./BlockGroup.vue?vue&type=script&lang=js"
export * from "./BlockGroup.vue?vue&type=script&lang=js"
import style0 from "./BlockGroup.vue?vue&type=style&index=0&id=6dbdfabd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbdfabd",
  null
  
)

export default component.exports